<div class="banner-background relative z-0 flex items-end pt-7">
  <div class="banner-container mb-5 py-0 lg:mb-12 lg:pt-5">
    <h1
      class="banner-title m-0 text-[1.875rem] font-bold leading-[2.25rem] lg:mb-5 lg:text-[2.5rem] lg:leading-[3.75rem]">
      {{ 'homepage.banner_title' | translate }}
    </h1>
    <p
      class="banner-subtitle m-0 hidden text-[1rem] font-thin leading-[1.5rem] lg:block">
      {{ 'homepage.banner_subtitle' | translate }}
    </p>
  </div>
  <rd-banner-image [bannerImageConfig]="bannerImageConfig"></rd-banner-image>
</div>
